<template>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :height="size"
    :width="size"
    fill="none"
    :stroke="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path v-for="(path, index) in paths" :key="index" :d="path" />
  </svg>
</template>

<script>
const icons = {
  menu: [
    'M3 2v7c0 1.1 .9 2 2 2h4a2 2 0 0 0 2 -2V2',
    'M7 2v20',
    'M21 15V2a5 5 0 0 0 -5 5v6c0 1.1 .9 2 2 2h3zm0 0v7',
  ],
  order: [
    'M3 2v7c0 1.1 .9 2 2 2h4a2 2 0 0 0 2 -2V2',
    'M7 2v20',
    'M21 15V2a5 5 0 0 0 -5 5v6c0 1.1 .9 2 2 2h3zm0 0v7',
  ],
  bill: [
    'M4 2v20l2 -1l2 1l2 -1l2 1l2 -1l2 1l2 -1l2 1V2l-2 1l-2 -1l-2 1l-2 -1l-2 1l-2 -1l-2 1z',
    'M14 8H8',
    'M16 12H8',
    'M13 16H8',
  ],
  history: [
    'M3 12a9 9 0 1 0 9 -9a9.75 9.75 0 0 0 -6.74 2.74L3 8',
    'M3 3v5h5',
    'M12 7v5l4 2',
  ],
  review: [
    'M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z',
  ],
  tip: [
    'M2 8a6 6 0 1 0 12 0a6 6 0 1 0 -12 0',
    'M18.09 10.37A6 6 0 1 1 10.34 18',
    'M7 6h1v4',
    'M16.71 13.88l.7 .71l-2.82 2.82',
  ],
  callWaiter: [
    'M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z',
    'M20 16a8 8 0 1 0-16 0',
    'M12 4v4',
    'M10 4h4',
  ],
  userRound: ['M7 8a5 5 0 1 0 10 0a5 5 0 1 0 -10 0', 'M20 21a8 8 0 0 0 -16 0'],
  link: [
    'M9 15l6 -6',
    'M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464',
    'M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463',
  ],
};

export default {
  props: {
    name: {
      required: true,
      type: String,
    },
    color: {
      required: false,
      type: String,
      default: 'currentColor',
    },
    size: {
      required: false,
      type: [Number, String],
      default: 24,
    },
  },
  computed: {
    paths: function() {
      return icons[this.name] || icons.link;
    },
  },
};
</script>
